import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAIBhWAMGPQt9Feog1WQN2MHBmqAf1oTjo",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "fleurs-de.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "fleurs-de",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "fleurs-de.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "462942962508",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:462942962508:web:a9779b4c5899eb717945e9",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-P89DKXTB1H"
};

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || "BEIRXwfbbFl15QVF9_9gzocSKRHSkwHpdX3aeGdr8pMgLJJ8IAkFc0zPQg_Z7jRGSbKCm53_SXdGqUKzAsH59I0";

let app = null;
let messaging = null;

export function initFirebaseWeb() {
  if (app) return { app, messaging };
  try {
    app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
    return { app, messaging };
  } catch (error) {
    console.error('Firebase init error:', error);
    return { app: null, messaging: null };
  }
}

export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    return { granted: false, reason: 'not_supported' };
  }

  if (Notification.permission === 'granted') {
    return { granted: true, alreadyGranted: true };
  }

  if (Notification.permission === 'denied') {
    return { granted: false, reason: 'denied' };
  }

  const permission = await Notification.requestPermission();
  return { granted: permission === 'granted', reason: permission };
}

export async function getWebPushToken() {
  try {
    const { messaging: msg } = initFirebaseWeb();
    if (!msg) return null;

    // Register service worker
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    const token = await getToken(msg, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });

    return token;
  } catch (error) {
    console.error('Error getting web push token:', error);
    return null;
  }
}

export function onForegroundMessage(callback) {
  const { messaging: msg } = initFirebaseWeb();
  if (!msg) return () => {};

  return onMessage(msg, (payload) => {
    callback(payload);
  });
}
